import React from 'react';
import { motion } from 'framer-motion';
import { Brain, GitBranch, ShieldAlert, HeartPulse, Users, Compass, Scale } from 'lucide-react';
export function PlatformCapabilities() {
  const capabilities = [{
    icon: <Brain size={20} data-id="element-302" />,
    title: 'Reasoning Quality',
    desc: 'The ability to evaluate claims, weigh evidence, detect contradictions, and process complexity with clarity.'
  }, {
    icon: <GitBranch size={20} data-id="element-303" />,
    title: 'Consequential Thinking',
    desc: 'The ability to understand tradeoffs, anticipate second-order effects, and think beyond immediate reaction.'
  }, {
    icon: <ShieldAlert size={20} data-id="element-304" />,
    title: 'Manipulation Resistance',
    desc: 'The ability to detect propaganda, rhetorical deception, emotional framing, ideological capture, and disinformation.'
  }, {
    icon: <HeartPulse size={20} data-id="element-305" />,
    title: 'Emotional Regulation',
    desc: 'The ability to remain stable under stress, reduce reactivity, and make stronger decisions under pressure.'
  }, {
    icon: <Users size={20} data-id="element-306" />,
    title: 'Social Cooperation',
    desc: 'The ability to handle disagreement, navigate group dynamics, and contribute constructively within teams, institutions, and communities.'
  }, {
    icon: <Compass size={20} data-id="element-307" />,
    title: 'Self-Direction & Execution',
    desc: 'The ability to follow through, organize effort, maintain discipline, and convert goals into action.'
  }, {
    icon: <Scale size={20} data-id="element-308" />,
    title: 'Leadership Responsibility',
    desc: 'The ability to manage complexity, absorb dissent, prioritize institutional duty, and exercise power with greater stability and foresight.',
    featured: true
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto border-t border-line" data-id="element-309">
      <div className="max-w-3xl mb-16" data-id="element-310">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-311">
          Core Capability Domains
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark mb-6" data-id="element-312">
          The foundations of judgment, readiness, and responsibility
        </h2>
        <p className="text-lg text-ink-muted leading-relaxed" data-id="element-313">
          Across the platform, SyNeural focuses on a set of core human
          capabilities that shape how individuals function, how institutions
          perform, and how leaders govern.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-314">
        {capabilities.map((cap, index) => <motion.div key={cap.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.05
      }} className={`bg-surface-card p-8 rounded-lg border border-line shadow-sm hover:shadow-md transition-shadow ${cap.featured ? 'md:col-span-2 lg:col-span-3 lg:w-2/3 mx-auto bg-surface-muted/50 border-navy/20' : ''}`} data-id="element-315">
            <div className={`w-10 h-10 rounded-md flex items-center justify-center mb-6 ${cap.featured ? 'bg-navy text-white' : 'bg-surface-muted text-navy-light border border-line'}`} data-id="element-316">
              {cap.icon}
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3" data-id="element-317">
              {cap.title}
            </h3>
            <p className="text-ink-muted leading-relaxed" data-id="element-318">{cap.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}